/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientContactWithDetails } from './ClientContactWithDetails';
import {
    ClientContactWithDetailsFromJSON,
    ClientContactWithDetailsFromJSONTyped,
    ClientContactWithDetailsToJSON,
} from './ClientContactWithDetails';
import type { InputMethod } from './InputMethod';
import {
    InputMethodFromJSON,
    InputMethodFromJSONTyped,
    InputMethodToJSON,
} from './InputMethod';
import type { LifeCycleTransaction } from './LifeCycleTransaction';
import {
    LifeCycleTransactionFromJSON,
    LifeCycleTransactionFromJSONTyped,
    LifeCycleTransactionToJSON,
} from './LifeCycleTransaction';
import type { PolicyEvaluation } from './PolicyEvaluation';
import {
    PolicyEvaluationFromJSON,
    PolicyEvaluationFromJSONTyped,
    PolicyEvaluationToJSON,
} from './PolicyEvaluation';
import type { ServiceContactWithDetails } from './ServiceContactWithDetails';
import {
    ServiceContactWithDetailsFromJSON,
    ServiceContactWithDetailsFromJSONTyped,
    ServiceContactWithDetailsToJSON,
} from './ServiceContactWithDetails';
import type { UserGroups } from './UserGroups';
import {
    UserGroupsFromJSON,
    UserGroupsFromJSONTyped,
    UserGroupsToJSON,
} from './UserGroups';

/**
 * 
 * @export
 * @interface ClientEntity
 */
export interface ClientEntity {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    rID: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientEntity
     */
    createdAtUtc: Date;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    createdByUserRID: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientEntity
     */
    lastUpdatedAtUtc?: Date | null;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    lastUpdatedByUserRID?: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    containerRID: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    membersGroupRID: string;
    /**
     * The internal name for the organization entity
     * @type {string}
     * @memberof ClientEntity
     */
    internalName: string;
    /**
     * An optional unique identifier for the entity that may be provided from an external system
     * @type {string}
     * @memberof ClientEntity
     */
    uniqueIdentifier?: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientEntity
     */
    metadataSchemaRID?: string;
    /**
     * 
     * @type {object}
     * @memberof ClientEntity
     */
    metadata?: object;
    /**
     * 
     * @type {{ [key: string]: PolicyEvaluation; }}
     * @memberof ClientEntity
     */
    actions?: { [key: string]: PolicyEvaluation; };
    /**
     * 
     * @type {Array<ClientContactWithDetails>}
     * @memberof ClientEntity
     */
    clientContacts?: Array<ClientContactWithDetails>;
    /**
     * 
     * @type {Array<ServiceContactWithDetails>}
     * @memberof ClientEntity
     */
    serviceContacts?: Array<ServiceContactWithDetails>;
    /**
     * 
     * @type {UserGroups}
     * @memberof ClientEntity
     */
    userGroups?: UserGroups;
    /**
     * 
     * @type {InputMethod}
     * @memberof ClientEntity
     */
    inputMethod?: InputMethod;
    /**
     * 
     * @type {LifeCycleTransaction}
     * @memberof ClientEntity
     */
    lifeCycleTransaction?: LifeCycleTransaction;
}

/**
 * Check if a given object implements the ClientEntity interface.
 */
export function instanceOfClientEntity(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;
    isInstance = isInstance && "createdAtUtc" in value;
    isInstance = isInstance && "createdByUserRID" in value;
    isInstance = isInstance && "containerRID" in value;
    isInstance = isInstance && "membersGroupRID" in value;
    isInstance = isInstance && "internalName" in value;

    return isInstance;
}

export function ClientEntityFromJSON(json: any): ClientEntity {
    return ClientEntityFromJSONTyped(json, false);
}

export function ClientEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByUserRID': json['createdByUserRID'],
        'lastUpdatedAtUtc': !exists(json, 'lastUpdatedAtUtc') ? undefined : (json['lastUpdatedAtUtc'] === null ? null : new Date(json['lastUpdatedAtUtc'])),
        'lastUpdatedByUserRID': !exists(json, 'lastUpdatedByUserRID') ? undefined : json['lastUpdatedByUserRID'],
        'containerRID': json['containerRID'],
        'membersGroupRID': json['membersGroupRID'],
        'internalName': json['internalName'],
        'uniqueIdentifier': !exists(json, 'uniqueIdentifier') ? undefined : json['uniqueIdentifier'],
        'metadataSchemaRID': !exists(json, 'metadataSchemaRID') ? undefined : json['metadataSchemaRID'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'actions': !exists(json, 'actions') ? undefined : (mapValues(json['actions'], PolicyEvaluationFromJSON)),
        'clientContacts': !exists(json, 'clientContacts') ? undefined : ((json['clientContacts'] as Array<any>).map(ClientContactWithDetailsFromJSON)),
        'serviceContacts': !exists(json, 'serviceContacts') ? undefined : ((json['serviceContacts'] as Array<any>).map(ServiceContactWithDetailsFromJSON)),
        'userGroups': !exists(json, 'userGroups') ? undefined : UserGroupsFromJSON(json['userGroups']),
        'inputMethod': !exists(json, 'inputMethod') ? undefined : InputMethodFromJSON(json['inputMethod']),
        'lifeCycleTransaction': !exists(json, 'lifeCycleTransaction') ? undefined : LifeCycleTransactionFromJSON(json['lifeCycleTransaction']),
    };
}

export function ClientEntityToJSON(value?: ClientEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
        'createdAtUtc': (value.createdAtUtc.toISOString()),
        'createdByUserRID': value.createdByUserRID,
        'lastUpdatedAtUtc': value.lastUpdatedAtUtc === undefined ? undefined : (value.lastUpdatedAtUtc === null ? null : value.lastUpdatedAtUtc.toISOString()),
        'lastUpdatedByUserRID': value.lastUpdatedByUserRID,
        'containerRID': value.containerRID,
        'membersGroupRID': value.membersGroupRID,
        'internalName': value.internalName,
        'uniqueIdentifier': value.uniqueIdentifier,
        'metadataSchemaRID': value.metadataSchemaRID,
        'metadata': value.metadata,
        'actions': value.actions === undefined ? undefined : (mapValues(value.actions, PolicyEvaluationToJSON)),
        'clientContacts': value.clientContacts === undefined ? undefined : ((value.clientContacts as Array<any>).map(ClientContactWithDetailsToJSON)),
        'serviceContacts': value.serviceContacts === undefined ? undefined : ((value.serviceContacts as Array<any>).map(ServiceContactWithDetailsToJSON)),
        'userGroups': UserGroupsToJSON(value.userGroups),
        'inputMethod': InputMethodToJSON(value.inputMethod),
        'lifeCycleTransaction': LifeCycleTransactionToJSON(value.lifeCycleTransaction),
    };
}

